import { render, staticRenderFns } from "./ObrasServicosDetails.vue?vue&type=template&id=7f4f2a03&"
import script from "./ObrasServicosDetails.vue?vue&type=script&lang=js&"
export * from "./ObrasServicosDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports